import {
  isEditOptionCode,
  isColorToolOptionChoice,
} from '@photosi/rn-components/toolbars/base-toolbar/BaseToolbar.utils';
import { getColorToolOptionKey } from '@photosi/rn-components/toolbars/base-toolbar/toolbar-options/tool-options-renderer/color-tool/color-tool-option/ColorToolOption.utils';
import { LookupCodes } from 'src/constants/lookup.constants';
import { ProductOptionChoiceDetailsInstance } from 'src/store/_models/productOptionChoiceDetails';

export const getToolOptionChoiceTitleI18nKey = (
  productFamily?: string,
  optionCode?: string,
  choiceCode?: string,
  choiceDetails?: ProductOptionChoiceDetailsInstance,
): string => {
  return isColorToolOptionChoice(optionCode, choiceDetails)
    ? getColorToolOptionChoiceI18nKey(choiceDetails?.color)
    : getToolOptionChoiceI18nKey(productFamily, optionCode, choiceCode, '');
};

export const getToolOptionChoiceDescriptionI18nKey = (
  productFamily?: string,
  optionCode?: string,
  choiceCode?: string,
): string => {
  return getToolOptionChoiceI18nKey(productFamily, optionCode, choiceCode, '-description');
};

export const getToolOptionTitleI18nKey = (optionCode?: string): string => {
  if (optionCode) {
    const prefix = isEditOptionCode(optionCode) ? 'edit' : 'lookups';
    return `${prefix}:${optionCode}`;
  } else {
    return '';
  }
};

export const getToolOptionDescriptionI18nKey = (optionCode?: string): string => {
  return optionCode ? `${getToolOptionTitleI18nKey(optionCode)}-description` : '';
};

export const getToolOptionGroupI18nKey = (
  optionCode?: string,
  currentGroupCode?: string,
  otherGroupCode?: string,
): string => {
  let key = '';
  if (optionCode && currentGroupCode) {
    if (otherGroupCode) {
      key = `lookups:${optionCode}-group-${currentGroupCode}-referencing-${otherGroupCode}`;
    } else {
      key = `lookups:${optionCode}-group-${currentGroupCode}`;
    }
  }
  return key;
};

export const getFormatI18nKey = (productFamily?: string, choiceCode?: string): string => {
  return getToolOptionChoiceI18nKey(productFamily, LookupCodes.FORMAT, choiceCode);
};

export const getPaperI18nKey = (productFamily?: string, choiceCode?: string): string => {
  return getToolOptionChoiceI18nKey(productFamily, LookupCodes.PAPER, choiceCode);
};

export const getToolOptionChoiceI18nKey = (
  productFamily?: string,
  optionCode?: string,
  choiceCode?: string,
  suffix: string = '',
): string => {
  if (productFamily && choiceCode && optionCode) {
    if (isEditOptionCode(optionCode)) {
      return `${optionCode}:${choiceCode}${suffix}`;
    } else {
      return `lookups-options:${productFamily}:${optionCode}-${choiceCode}${suffix}`;
    }
  } else {
    return '';
  }
};

export const getColorI18nKey = (colorKey: string): string => {
  return `colors:${colorKey}`;
};

export const getHintI18nKey = (hintKey: string): string => {
  return `hints:${hintKey}`;
};

export const getFormatVariableI18nKey = (productFamily?: string): string => {
  return `lookups-options:${productFamily}:${LookupCodes.FORMAT}-${LookupCodes.VARIABLE}`;
};

export const getColorToolOptionChoiceI18nKey = (color?: string): string => {
  return color ? getColorI18nKey(getColorToolOptionKey(color)) : '';
};

export const getKitSetVariableI18nKey = (setType: string): string => {
  return `lookups-options:kit-type:${setType}`;
};
